import { CollateralSetCTO } from '@shared/CollateralSetCTO'
import { EthAddr } from '@shared/SchemaTypes'
import axios from 'axios'
import { User } from 'oidc-client-ts'

export const fetchCollateral = async (
  serverApiBaseUrl: string,
  restAPIKey: string,
  poolAddr: EthAddr
): Promise<CollateralSetCTO | undefined> => {
  const r = await axios.get(`${serverApiBaseUrl}/collateral/${poolAddr}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })
  // Adjust if your API response structure is different
  return r.data.collateralSetCTO
}

export const saveCollateral = async (
  serverApiBaseUrl: string,
  collateralSetCTO: CollateralSetCTO,
  cognitoUser?: User
): Promise<CollateralSetCTO> => {
  const accessToken = cognitoUser?.access_token
  const r = await axios.put(`${serverApiBaseUrl}/collateral`, collateralSetCTO, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      // 'x-api-key': restAPIKey, // include if still needed
    },
  })
  return r.data.collateralSetCTO
}
